import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import { AuthPageWrapper } from '@app/components';

import { PreregistrationForm } from './PreregistrationForm';

const cnBem = createBemBlockBuilder(['authPageWrapper']);

export const PreregistrationPage = () => {
  const { $t } = useIntl();

  return (
    <>
      <Helmet>
        <title>
          {$t({
            id: 'preregistration.formTitle',
            defaultMessage: 'Preregister for a Reader Identification Card',
          })}
        </title>
      </Helmet>
      <AuthPageWrapper containerClassName={cnBem('__preregisterContainer')}>
        <PreregistrationForm />
      </AuthPageWrapper>
    </>
  );
};
